module.exports = __webpack_public_path__ + "static/media/word-scramble.4a6c60bf.png";